import React from "react"

const NoMatchPage = () => {
    return <>
        {"NoMatch"}
    </>
}

export default NoMatchPage;